import React, { useEffect, useReducer } from 'react';

// REDUX
import { getFixesState, getNumberOfReels, setFixesState } from '@Managers/Redux/AppState/AppState';
import { TFixesStateData } from '@Managers/Redux/AppState/AppState.types';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import LocalStorageItem from '@Managers/Storage/LocalStorageItem';
import LocalStorageManager from '@Managers/Storage/LocalStorageManager';
import { LocalStorageItemKeys } from '@Managers/Storage/LocalStorageManager.types';
import { FixStateDefault, IFixData } from './Fixes.types';

import FixesCombinations from './Combinations/Fixes.combinations';
import FixesSelector from './Selector/Fixes.selector';

// STYLES
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import HttpService from '@Services/HttpService/HttpService';
import { TUserActionResponse } from '@Services/HttpService/HttpService.types';
import styles from './Fixes.scss';
import FixesList from './List/Fixes.list';

function Fixes() {
    const [state, setState] = useReducer((state: { init: boolean }, newState: {}) => ({ ...state, ...newState }), { init: false });

    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);
    const gameStoreNumberOfReels = useAppSelector(getNumberOfReels);

    useEffect(() => {
        if (state.init) {
            LocalStorageManager.saveItem(
                new LocalStorageItem(
                    LocalStorageItemKeys.LOCAL_FIXES,
                    JSON.stringify({ fixArray: fixesState.fixArray, fixCombinations: fixesState.fixCombinations, saveOnRefresh: fixesState.saveOnRefresh })
                )
            );
        }
    }, [fixesState]);

    function saveOnRefresh() {
        dispatch(setFixesState({ saveOnRefresh: !fixesState.saveOnRefresh }));
    }

    function reset() {
        const fixData: IFixData = {};
        for (var i = 0; i < gameStoreNumberOfReels; i++) {
            fixData[i] = 0;
        }
        dispatch(setFixesState({ ...FixStateDefault, fixReelPosition: fixData }));
    }

    function getGameFixesReqest() {
        const data = HttpService.getFixesRequest();
        data.then((response: TUserActionResponse) => {
            if (response.spin && response.spin?.length > 0) {
                dispatch(setFixesState({ fixArrayPredefined: [...fixesState.fixArrayPredefined, ...response.spin] }));
            }
        });
    }

    useEffect(() => {
        const localFix = (LocalStorageManager.readItem(LocalStorageItemKeys.LOCAL_FIXES) as TFixesStateData) ?? {};

        if (!localFix.saveOnRefresh) localFix.fixCombinations = [];

        if (localFix) {
            dispatch(setFixesState({ ...localFix }));
        } else {
            dispatch(setFixesState(FixStateDefault));
        }

        if (ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).debugTools?.getGameFixes) getGameFixesReqest();

        setState({ init: true });
    }, []);

    return (
        <>
            <div className={styles.fix_container}>
                <div className={styles.fix_group_col}>
                    <FixesSelector />
                    <FixesList />
                </div>
                <div className={styles.fix_group_col}>
                    <FixesCombinations />
                </div>
                <div className={styles.fix_footer}>
                    <div>
                        <button className={styles.fix_reset_btn} onClick={(evt) => saveOnRefresh()}>
                            Save on refresh: {fixesState.saveOnRefresh ? 'ON' : 'OFF'}
                        </button>
                    </div>
                    <div>
                        <button className={styles.fix_reset_btn} onClick={(evt) => reset()}>
                            Set defaults
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Fixes;
